import React from 'react';

const Link = ({ to, children, className, ...props }) => {
    const handleClick = (e) => {
        e.preventDefault();
        const newPath = to === 'about' ? '/about' : '/';
        window.history.pushState({}, '', newPath);
        
        // Dispatch a custom event to trigger navigation
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo(0, 0);
    };

    return (
        <a 
            href={to === 'about' ? '/about' : '/'} 
            onClick={handleClick}
            className={className}
            {...props}
        >
            {children}
        </a>
    );
};

export default Link;
